import { Collapse, Grid, MenuItem, Typography } from '@mui/material';
import { LoadingSpinner } from '../../../core/LoadingSpinner';
import { CustomeTextField } from '../../../generic/CustomeTextField';
import { useGetCountries } from '../../../hooks/data';
import {
  staticContractObjectSubtypeArray,
  staticContractObjectTypeArray,
} from '../../../Interfaces/IContractObjectType';
import { ILegalTransactionRelationshipDataSignatureCertificationV1 } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';

import { ViewComponent } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';

export const SignatureCertificationRelationshipDataView: ViewComponent<
  ILegalTransactionRelationshipDataSignatureCertificationV1
> = ({ data, setData }) => {
  const { countries, isLoadingCountries } = useGetCountries();

  if (isLoadingCountries) {
    return <LoadingSpinner />;
  }

  if (!countries) {
    return null;
  }

  const isFreeText = staticContractObjectSubtypeArray.find(
    x => x.idContactObjectSubtype === data.idContactObjectSubtype
  )?.allowFreeText;

  return (
    <div>
      <Typography variant='h6' sx={{ mt: 5, mb: 2 }}>
        Zusätzliche Daten Unterschriftenbeglaubigung
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomeTextField
            attr='idContractObjectType'
            label='Vertragsart'
            object={data}
            setObject={(
              upObj: ILegalTransactionRelationshipDataSignatureCertificationV1
            ) =>
              setData({
                ...upObj,
              })
            }
            type='select'
            required
            null
          >
            {staticContractObjectTypeArray.map(contractType => (
              <MenuItem
                key={`contracttype-${contractType.idContractObjectType}`}
                value={contractType.idContractObjectType}
              >
                {contractType.contractObjectType}
              </MenuItem>
            ))}
          </CustomeTextField>
        </Grid>
        <Grid item xs={12}>
          <Collapse
            in={
              data.idContractObjectType !== null &&
              data.idContractObjectType > 0
            }
          >
            <CustomeTextField
              attr='idContactObjectSubtype'
              label='Vertragsinhalt'
              object={data}
              setObject={setData}
              type='select'
              required
              null
            >
              {staticContractObjectSubtypeArray
                .filter(
                  x => x.idContractObjectType === data.idContractObjectType
                )
                .map(contractType => (
                  <MenuItem
                    key={`contractsubtype-${contractType.idContactObjectSubtype}`}
                    value={contractType.idContactObjectSubtype}
                  >
                    {contractType.contactObjectSubtype}
                  </MenuItem>
                ))}
            </CustomeTextField>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <Collapse in={isFreeText}>
            <CustomeTextField
              attr='textcontactObjectSubtype'
              label='Vertragsinhalt'
              object={data}
              setObject={setData}
              type='string'
              required={isFreeText}
              rows={2}
            />
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <CustomeTextField
            attr='idCountryTextLanguage'
            label='Sprache des Textes'
            object={data}
            setObject={(
              upObj: ILegalTransactionRelationshipDataSignatureCertificationV1
            ) =>
              setData({
                ...upObj,
                idCountryTextLanguage: upObj.idCountryTextLanguage || 1, // Default to German
              })
            }
            type='select'
            required
            null
          >
            {countries
              .sort((a, b) => (a.Nationality < b.Nationality ? -1 : 1))
              .map(country => (
                <MenuItem
                  key={`lanuage-idcounrtry-${country.idCountry}`}
                  value={country.idCountry}
                >
                  {country.Nationality}
                </MenuItem>
              ))}
          </CustomeTextField>
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField
            attr='idCountryUseOfText'
            label='Verwendung des Textes'
            object={data}
            setObject={(
              upObj: ILegalTransactionRelationshipDataSignatureCertificationV1
            ) =>
              setData({
                ...upObj,
              })
            }
            type='select'
            required
            null
          >
            {countries
              .sort((a, b) => (a.Country < b.Country ? -1 : 1))
              .map(country => (
                <MenuItem
                  key={`lanuage-idcounrtry-${country.idCountry}`}
                  value={country.idCountry}
                >
                  {country.Country}
                </MenuItem>
              ))}
          </CustomeTextField>
        </Grid>

        <Grid item xs={12}>
          <CustomeTextField
            attr='notes'
            label='Anmerkungen'
            object={data}
            setObject={setData}
            type='string'
            rows={5}
          />
        </Grid>
      </Grid>
    </div>
  );
};
